const STOREID = 10001;
const APIBASEURL = "https://app.cannacabana.de/api";
const CLIENTID = '1';
const CLIENTSECRET = 'e8kUP00KkZsO2eNdgIHYyfGvVX5SSKBKIdobbmMj';
const SSOCLIENT = 'OBshAeagcrzfWnczti7jTw==:SrQ03Qn24qCLSIjZilRVpT4c+CdiZ/fP70UQ55alQ42MWuHXg0I2gwSqtGPI0WbB' 



// STOREID = 3134;
// APIBASEURL = "https://app.cannacabana.com/api";
// CLIENTID = '7';
// CLIENTSECRET = 'dqo3pUrSPyN0ONslDAzw1oHaxXs5KZ3D38DcNqLa';

// API ENDPOINTS
const BESTSELLER_URI = `/shopify/${STOREID}/carousel/best-seller`;
const COLLECTION_URL = `/product/filterv2?collection=[COLLECTION]&storeId=${STOREID}&limit=[LIMIT]&page=[PAGE]&sortOrder=[SORT_ORDER]&sortField=[SORT_FIELD]`;
const SINGLE_PRODUCT_URL = `/product/scan-single-item/${STOREID}`
const CART_ITEMS_URL = `/product/scan-multiple-items/${STOREID}`

let cachedToken = null;
let tokenExpiry = null;

async function getApiAccessToken(forceRefresh = false) {
    if (!forceRefresh && cachedToken && tokenExpiry && Date.now() < tokenExpiry) {
        return cachedToken;
    }
    // Check localStorage
    if (!forceRefresh) {
        const storedToken = localStorage.getItem("api_token");
        const storedExpiry = localStorage.getItem("api_token_expiry");
        if (storedToken && storedExpiry && Date.now() < parseInt(storedExpiry, 10)) {
            cachedToken = storedToken;
            tokenExpiry = parseInt(storedExpiry, 10);
            return cachedToken;
        }
    }
    try {
      const response = await fetch(`${APIBASEURL}/oauth/token`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          client_id: CLIENTID,
          client_secret: CLIENTSECRET,
          grant_type: 'client_credentials',
        }),
      });
  
      if (!response.ok) {
        throw new Error(`Access token fetch failed: ${response.statusText}`);
      }
  
      const data = await response.json();
      cachedToken = data.access_token;
      tokenExpiry = Date.now() + ((data.expires_in || 31536000) * 1000);

      localStorage.setItem("api_token", cachedToken);
      localStorage.setItem("api_token_expiry", tokenExpiry);

      return cachedToken;
    } catch (error) {
      console.error('Error retrieving access token:', error);
      return null;
    }
}

// async function apiFetch(endpoint, options = {}, retry = true) {
//     let token = await getApiAccessToken();
  
//     const resp = await fetch(`${APIBASEURL}${endpoint}`, {
//       ...options,
//       headers: {
//         ...(options.headers || {}),
//         Authorization: `Bearer ${token}`,
//       },
//     });
  
//     // If token invalid → refresh + retry once
//     if (resp.status === 401 && retry) {
//       console.warn("Token expired, refreshing...");
//       token = await getApiAccessToken(true); // force refresh
//       if (!token) throw new Error("Unable to refresh token");
  
//       return apiFetch(endpoint, options, false); // retry once without infinite loop
//     }
  
//     if (!resp.ok) {
//       throw new Error(`API request failed: ${resp.status} ${resp.statusText}`);
//     }
  
//     return resp.json();
// }

async function apiFetch(endpoint, options = {}, retry = true) {
  let token = await getApiAccessToken();

  // Automatically stringify object bodies if not already done
  let body = options.body;
  if (body && typeof body === "object" && !(body instanceof FormData)) {
    body = JSON.stringify(body);
  }

  const resp = await fetch(`${APIBASEURL}${endpoint}`, {
    ...options,
    body,
    headers: {
      "Content-Type": body ? "application/json" : undefined, // only set if JSON
      ...(options.headers || {}),
      Authorization: `Bearer ${token}`,
    },
  });

  // Handle expired token once
  if (resp.status === 401 && retry) {
    console.warn("Token expired, refreshing...");
    token = await getApiAccessToken(true); // force refresh
    if (!token) throw new Error("Unable to refresh token");

    return apiFetch(endpoint, options, false); // retry once
  }

  if (!resp.ok) {
    const text = await resp.text().catch(() => "");
    throw new Error(`API request failed: ${resp.status} ${resp.statusText} → ${text}`);
  }

  return resp.json();
}


async function fetchBestSeller() {
    try {
      const results = await apiFetch(BESTSELLER_URI);
      return results.data;
    } catch (err) {
      console.error("Error fetching Best Seller:", err);
    }
}
async function fetchProductsByCollection(handle, {
    limit = 20,
    page = 1,
    sortOrder = "asc",
    sortField = "title"
  } = {}) {
    let URI = COLLECTION_URL
      .replace("[COLLECTION]", encodeURIComponent(handle))
      .replace("[LIMIT]", limit)
      .replace("[PAGE]", page)
      .replace("[SORT_ORDER]", sortOrder)
      .replace("[SORT_FIELD]", sortField);
  
    try {
      const results = await apiFetch(URI);
      return results.data || [];
    } catch (err) {
      console.error(`Error fetching collection "${handle}":`, err);
      return [];
    }
}

async function fetchProduct(sku, variantId) {
  const URI = SINGLE_PRODUCT_URL;

  try {
    const response = await fetch(`${APIBASEURL}${URI}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}` // Uncomment if token is needed
      },
      body: JSON.stringify({
        skus: [{ [sku]: variantId }]
      })
    });

    const results = await response.json();
    return results.data || [];
  } catch (err) {
    console.error(`Error fetching product for SKU "${sku}":`, err);
    return [];
  }
}


async function getCollectionProducts(token) {
    try {
      const response = await fetch(`${APIBASEURL}/shopify/${STOREID}/carousel/best-seller`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
         'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        throw new Error(`Best seller products fetch failed: ${response.statusText}`);
      }
  
      const result  = await response.json();
      return { data } = result.data;
    } catch (error) {
      console.error('Error fetching Best Seller:', error);
      return [];
    }
}

async function scanMultipleItems(skus) {
  try {
      const results = await apiFetch(CART_ITEMS_URL, {
          method: "POST",
          body: { skus: skus }, 
        });
      return results;
    } catch (err) {
      console.error("Error fetching Multiple Items:", err);
    }
}

async function getStoreMetaData(){
    try{ 

      const token = await getAccessToken()
      const resp = await fetch(`${baseServerURL}/ihj-store/${store_id}/get` , {
        method:"POST",
        headers:{
          "Content-Type":"application/json",
          'Authorization' : `Bearer ${token}`
        },
        body:JSON.stringify({
          key : [ 'sales_tax', 'pst_tax', 'pst_sk_tax', 'vape_tax', 'gst_tax', 'hst_tax' , 'payment_options' , 'delivery_option' , 'delivery_hours']
        })
      })

      const data = await resp.json()
      const details = data.data
      cannaStoreDetails = details; 
 

    }catch(e){
      console.error(e)
    }
  }
  async function fetchShopifyProductByHandle(handle) {
          if (productCache.has(handle)) return productCache.get(handle);
          try {
            const res = await fetch(`/products/${handle}.js`);
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const json = await res.json();
            productCache.set(handle, json);
            return json;
          } catch (e) {
            console.error('Product fetch failed for handle', handle, e);
            return null;
          }
}

async function loginCustomer(email, password, errorDiv, elite = false) {
    const url = `${internalSSO}/auth/authenticate`;
    try {
      const emailexists = await checkEmailExists(email);
      if (emailexists.exists) {
        errorDiv.textContent = '';
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            userData: {
              client: client,
              email: email,
              password: password,
              login_type: 'password',
              return_to: btoa(window.location.href),
            },
          }),
        });
        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }

        const json = await response.json();
        console.log(json);
        window.location.href = json.redirect_uri;
      } else {
        errorDiv.textContent = 'Email does not exist';
      }
    } catch (error) {
      console.error(error.message);
      errorDiv.textContent = 'Invalid email or password';
    }
  }